import * as Yup from 'yup';
import gPhoneNumber from 'google-libphonenumber';
import {isNullOrUndefined} from "presentation/common";

const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance();

const YUP_PHONE_METHOD = 'phone';
const CLDR_REGION_CODE_SIZE = 2;

const isValidCountryCode = (countryCode) =>
  typeof countryCode === 'string' &&
  countryCode.length === CLDR_REGION_CODE_SIZE;

Yup.addMethod(Yup.string, YUP_PHONE_METHOD, function yupPhone(
  countryCode,
  pathField = 'phone',
  strict = false,
  errorMessage = ''
) {

  const errMsg =
    typeof errorMessage === 'string' && errorMessage
      ? errorMessage
      : 'El número de teléfono no es válido.';

  const nullable = this?.spec?.nullable;

  return this.test(YUP_PHONE_METHOD, function (value) {
    if(nullable && isNullOrUndefined(value)) {
      return true;
    }

    if (!isValidCountryCode(countryCode)) {
      // if not valid countryCode, then set default country to Chile (CL)
      countryCode = 'cl';
      strict = false;
    }

    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(value, countryCode);

      if (!phoneUtil.isPossibleNumber(phoneNumber)) {
        return this.createError({path: pathField, message: errMsg});
      }

      const regionCodeFromPhoneNumber = phoneUtil.getRegionCodeForNumber(
        phoneNumber
      );

      /* check if the countryCode provided should be used as
       default country code or strictly followed
     */
      const isValid = strict
        ? phoneUtil.isValidNumberForRegion(phoneNumber, countryCode)
        : phoneUtil.isValidNumberForRegion(
          phoneNumber,
          regionCodeFromPhoneNumber
        );

      return isValid ? true : this.createError({path: pathField, message: errMsg});

    } catch {
      return this.createError({path: pathField, message: errMsg});
    }
  });
});
